module.exports = __webpack_public_path__ + "static/media/front.3156d3d6.png";